import React, {
  useState,
  useEffect,
} from "react";

// Components
import {
  Select,
  Flex,
  Space,
  Radio,
  Row,
  Col,
  Card,
  Checkbox,
  Form,
  message,
  Table,
} from "antd";
import StepsHeading from "./StepsHeading";
import {
  CustomTitle,
  CustomButton,
  CustomParagraph,
  CustomInput,
  CustomSelect,
} from "../../../components";
import {
  GetNotificationModel,
  SendNotification,
  GetProducts,
  DeleteNotification,
} from "../../../api's/onboarding";
import { useToken } from "../../../common/helper";
import { useSpin } from "../../../components/SpinContext.js";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../assets/images/edit-icon.svg";
import deleteIcon from "../../../assets/images/delete.svg";
import { CheckOutlined } from "@ant-design/icons";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'

const { Option } = Select;
const customStyle = {
  height: "36px",
  width: "100%",
  backgroundColor: "#F3F3F3",
  color: "#5E5E5E",
  borderRadius: "8px",
  lineHeight: "38px",
  boxShadow: "none",
  height: "36px",
  border: "0px",
};

const placeholderStyle = {
  "::placeholder": {
    color: "#5E5E5E",
  },
};

const Notifications = ({ onNext, onSuccess }, ref) => {
  const onFinish = (values) => {
    onNext();
  };

  const [form] = Form.useForm();
  const [value, setValue] = useState(0);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedFrequency, setFrequency] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const navigate = useNavigate();
  const [productList, setProductList] = useState();
  const [notificationList, setNotificationList] = useState([]);
  const [makeFrequencyDisable, setMakeFrequencyDisable] = useState(false);

  const [model, setModelData] = useState({
    is_critical: false,
    is_at_risk: false,
    is_pickup_confirmation: false,
    is_delivery_confirmation: false,
  });

  // const onRadioChange = (e) => {
  //   setValue(e.target.value);
  // };

  const handleSelectChange = (value) => {
    setSelectedOption(value);
    let val1 = selectedOption === "MOBILE" || selectedOption === "WHATSAPP" ? true : false;
    let val2 = value === "MOBILE" || value === "WHATSAPP" ? true : false
    if (val1 !== val2) {
      form.setFieldsValue({ notification_channel: "" });
    }
  };

  const handleFrequencyChange = (value) => {
    setFrequency(value);
    console.log(`Selected frequency: ${value}`);
  };

  const options = [];
  for (let i = 10; i < 36; i++) {
    options.push({
      label: i.toString(36) + i,
      value: i.toString(36) + i,
    });
  }
  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const fetchNotifications = () => {
    showSpin();
    GetNotificationModel(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let res = data?.data?.data?.length > 0 ? data.data.data : [];
            setNotificationList(res);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchProductLists = () => {
    showSpin();
    GetProducts(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let res = data.data.data;
            if (res) {
              setProductList(res);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  useEffect(() => {
    fetchProductLists();
  }, []);

  const handleEdit = (res) => {
    if (res) {
      const productIds = res?.products
        ? res.products.map((product) => product.id)
        : [];
      setModelData(res);
      form.setFieldsValue({
        alert_type: res.alert_type,
        notification_method: res.notification_method,
        frequency: res.frequency,
        notification_channel: res.notification_channel,
        products: productIds,
      });
      setSelectedOption(res.notification_method);
    }
  };

  const FormReset = () => {
    form.resetFields();
    setModelData({
      is_critical: false,
      is_at_risk: false,
      is_pickup_confirmation: false,
      is_delivery_confirmation: false,
    });
    setSelectedOption(null);
  };

  const cardData = [
    { value: "is_critical", label: "Critical alerts", name: "is_critical" },
    { value: "is_at_risk", label: "At-risk alerts", name: "is_at_risk" },
    {
      value: "is_pickup_confirmation",
      label: "Pickup confirmation",
      name: "is_pickup_confirmation",
    },
    {
      value: "is_delivery_confirmation",
      label: "Delivery confirmation",
      name: "is_delivery_confirmation",
    },
  ];

  const sendNotification = (model) => {
    SendNotification(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            FormReset();
            fetchNotifications();
            message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const handleDelete = (item) => {
    if (item && item?.id) {
      showSpin();
      DeleteNotification(item?.id, token)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              message.success(data?.data?.message);
              if(item?.id === model?.id){
                FormReset();
              }
              fetchNotifications();
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  const completeStep = () => {
    form
      .validateFields()
      .then((values) => {
        let formModel = {
          ...model,
          ...form.getFieldsValue(),
        };
        if (formModel) {
          //formModel.create_self = true;
          sendNotification(formModel);
        }
      })
      .catch((err) => { });
  };

  // useImperativeHandle(ref, () => ({
  //   //completeStep,  // Expose the submitProducts method to the parent
  // }));

  const onRadioChange = (e) => {
    const selectedValue = e.target.value;
    setMakeFrequencyDisable(false);
    if (selectedValue === "REAL_TIME") {
      form.setFieldsValue({ frequency: null });
      setMakeFrequencyDisable(true);
    }
  };

  const handleCardSelect = (value) => {
    setModelData((prevState) => ({
      ...prevState,
      [value]: !prevState[value], // Toggle the specific value
    }));
  };

  const initialValues = {
    alert_type: null,
    notification_method: null,
    frequency: null,
  };

  const columns = [
    {
      title: "Notification For",
      dataIndex: "products",
      key: "products",
      render: (products) => (
        <CustomParagraph
          noText="-"
          text={products.map((product) => product.name).join(", ")}
          fontSize={14}
          fontWeight={500}
          color="#000"
          marginBottom={0}
        />
      ),
    },
    // {
    //   title: "Notification Type",
    //   dataIndex: "alert_type",
    //   key: "alert_type",
    //   render: (text) => <CustomParagraph text={text} fontSize={14} fontWeight={400} color="#000" marginBottom={0} />,
    // },
    {
      title: "Notification Frequency",
      dataIndex: "alert_type",
      key: "alert_type",
      render: (text) => {
        const displayText = text === "REAL_TIME" ? "REAL TIME" : text;
        return (
          <CustomParagraph
            noText="-"
            text={displayText}
            fontSize={14}
            fontWeight={400}
            color="#000"
            marginBottom={0}
          />
        );
      },
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      render: (text) => (
        <CustomParagraph
          noText="-"
          text={text}
          fontSize={14}
          fontWeight={400}
          color="#000"
          marginBottom={0}
        />
      ),
    },
    {
      title: "Notification Method",
      dataIndex: "notification_method",
      key: "notification_method",
      render: (text) => (
        <CustomParagraph
          noText="-"
          text={text}
          fontSize={14}
          fontWeight={400}
          color="#000"
          marginBottom={0}
        />
      ),
    },
    {
      title: "Method Value",
      dataIndex: "notification_channel",
      key: "notification_channel",
      render: (text) => (
        <CustomParagraph
          noText="-"
          text={text}
          fontSize={14}
          fontWeight={400}
          color="#000"
          marginBottom={0}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <Flex>
          <Flex
            justify="center"
            align="center"
            style={{ width: "32px", height: "32px", cursor: "pointer" }}
          >
            <img src={editIcon} alt="" onClick={() => handleEdit(record)} />
          </Flex>
          <Flex
            justify="center"
            align="center"
            style={{ width: "32px", height: "32px", cursor: "pointer" }}
          >
            <img src={deleteIcon} alt="" onClick={() => handleDelete(record)} />
          </Flex>
        </Flex>
      ),
    },
  ];

  // const handleCardSelect = (value) => {
  //   // Toggle selection of card
  //   const newSelectedValues = selectedValues.includes(value)
  //     ? selectedValues.filter((item) => item !== value)
  //     : [...selectedValues, value];

  //   setSelectedValues(newSelectedValues);

  //   // Update form values based on selected card
  //   const updatedValues = {};
  //   cardData.forEach((card) => {
  //     updatedValues[card.value] = newSelectedValues.includes(card.value);
  //   });

  //   form.setFieldsValue(updatedValues);
  //   console.log(form.getFieldsValue())
  // };

  return (
    <>
      <div className="default-steps-content">
        <StepsHeading
          heading="Tell us how you’d like to receive alerts"
          text="Lastly, set up your notification preferences."
        />
        <Space
          direction="vertical"
          size="small"
          style={{ gap: 0, marginTop: "32px" }}
        >
          <CustomTitle
            text="Notify me about..."
            fontSize="14px"
            fontWeight="500"
            lineHeight="16px"
            color="black"
            marginBottom="0"
          />
          <CustomParagraph
            text="Select all that apply"
            fontSize="14px"
            fontWeight="400"
            lineHeight="20px"
            color="#4B4B4B"
            marginBottom="8px"
          />
        </Space>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={initialValues}
        >
          <Space direction="vertical" style={{ width: "100%" }} size="large">
            <Form.Item name="abc">
              <Row gutter={12}>
                {cardData.map((card) => (
                  <Col span={6} key={card.value}>
                    <Card
                      key={card.value}
                      onClick={() => handleCardSelect(card.value)}
                      style={{
                        width: "100%",
                        maxWidth: "255px",
                        borderRadius: "12px",
                        border: model[card.value]
                          ? "3px solid #000"
                          : "2px solid #EEEEEE",
                        cursor: "pointer",
                        padding: "0",
                      }}
                      className={model[card.value] ? "selected-card" : ""}
                      bodyStyle={{
                        padding: "16px",
                      }}
                    >
                      <Flex vertical={true} gap={16}>
                        <Flex justify="end">
                          <span className="custom-checkbox">
                            <CheckOutlined
                              style={{
                                color: "#fff",
                                width: "inherit",
                                fontSize: "16px",
                              }}
                            />
                          </span>

                          <Checkbox
                            style={{ position: "absolute", opacity: 0 }}
                            checked={model[card.value]}
                            onChange={() => handleCardSelect(card.value)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </Flex>
                        <CustomTitle
                          text={card.label}
                          fontSize="14px"
                          fontWeight="500"
                          lineHeight="16px"
                          color="black"
                          marginBottom="0"
                        />
                      </Flex>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Form.Item>
            <Row gutter={8}>
              <Col span={12}>
                <CustomTitle
                  text="For which products do you want to receive notifications?"
                  fontSize="14px"
                  fontWeight="500"
                  lineHeight="16px"
                  color="black"
                  marginBottom="8px"
                />
                <Form.Item name="products">
                  <Select
                    value=""
                    mode="multiple"
                    style={{ ...customStyle, ...placeholderStyle }}
                  >
                    {productList &&
                      productList.map((option, index) => (
                        <Option key={index} value={option.id}>
                          {option.name}
                        </Option>
                      ))}
                  </Select>
                  {/* <CustomSelect
                    mode="multiple"
                    allowClear={true}
                    placeholder="Please select"
                    defaultValue={["a10", "c12"]}
                    //options={Products}
                    // value={selectedFrequency}
                    // onChange={handleFrequencyChange}
                    width="100%"
                    height="36px"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    placeholderColor="#4B4B4B"
                  /> */}
                </Form.Item>
              </Col>
            </Row>
            <Space direction="vertical" align="start">
              <CustomTitle
                text="Notification frequency"
                fontSize="14px"
                fontWeight="500"
                lineHeight="16px"
                color="black"
                marginBottom="0"
              />
              <Form.Item name="alert_type">
                <Radio.Group onChange={onRadioChange} value={value}>
                  <Space direction="vertical" size="large" align="start">
                    <Radio value="REAL_TIME" style={{ gap: "8px" }}>
                      <Space direction="vertical" size="small" align="start">
                        <CustomTitle
                          text="Real-time"
                          fontSize="14px"
                          fontWeight="500"
                          lineHeight="16px"
                          color="black"
                          marginBottom="0"
                        />
                        <CustomTitle
                          text="Send me a notification for every alert"
                          fontSize="14px"
                          fontWeight="400"
                          lineHeight="20px"
                          color="#4B4B4B"
                          marginBottom="0"
                        />
                      </Space>
                    </Radio>
                    <Flex direction="vertical" gap="small" align="flex-end">
                      <Radio value="BATCHED" style={{ gap: "8px" }}>
                        <Space direction="vertical" size="small" align="start">
                          <CustomTitle
                            text="Batched alerts"
                            fontSize="14px"
                            fontWeight="500"
                            lineHeight="16px"
                            color="black"
                            marginBottom="0"
                          />
                          <CustomTitle
                            text="Send me a single summary of alerts every..."
                            fontSize="14px"
                            fontWeight="400"
                            lineHeight="20px"
                            color="#4B4B4B"
                            marginBottom="0"
                          />
                        </Space>
                      </Radio>

                      <Form.Item name="frequency">
                        <CustomSelect
                          placeholder="Select frequency"
                          width="200px"
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#4B4B4B"
                          disabled={makeFrequencyDisable}
                          options={[
                            { value: "15MIN", label: "Every 15 Mins" },
                            { value: "30MIN", label: "Every 30 Mins" },
                            { value: "1HR", label: "Every 1 Hour" },
                            // {
                            //   value: "DAILY_12PM",
                            //   label: "Every Day at 12PM Local Time",
                            // },
                            // {
                            //   value: "DAILY_12PM_5PM",
                            //   label: "Every Day at 12PM and 5PM Local Time",
                            // },
                            // {
                            //   value: "DAILY_5PM",
                            //   label: "Every Day at 5PM Local Time",
                            // },
                          ]}
                        />
                      </Form.Item>
                    </Flex>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Space>

            <Space direction="vertical" style={{ width: "100%" }}>
              <CustomTitle
                text="Preferred notification method"
                fontSize="14px"
                fontWeight="500"
                lineHeight="16px"
                color="black"
                marginBottom="0"
              />

              <Row gutter={8}>
                <Col span={6}>
                  <Form.Item name="notification_method">
                    <CustomSelect
                      placeholder="Select"
                      onChange={(value) => handleSelectChange(value)}
                      width="100%"
                      height="36px"
                      border="0px"
                      bgColor="#F3F3F3"
                      textColor="#5E5E5E"
                      borderRadius="8px"
                      //value={form.getFieldValue("notification_method")}
                      placeholderColor="#4B4B4B"
                      options={[
                        { value: "MOBILE", label: "SMS" },
                        { value: "EMAIL", label: "Email" },
                        { value: "SLACK", label: "Slack" },
                        { value: "TEAMS", label: "Teams" },
                        { value: "WHATSAPP", label: "WhatsApp" },
                      ]}
                    />
                  </Form.Item>
                </Col>

                {selectedOption && (
                  <Col span={6}>
                    <Form.Item
                      name="notification_channel"
                      rules={[{ required: true, message: `Please enter ${selectedOption === "MOBILE" || selectedOption === "WHATSAPP" ? 'mobile number' : 'email'}` }]}

                    >
                      {selectedOption === "MOBILE" ||
                        selectedOption === "WHATSAPP" ? (
                        <PhoneInput
                          country={"us"}
                          value={form.getFieldValue("notification_channel")}
                          onChange={(value, countryData, e, formattedValue) => {
                            form.setFieldsValue({ phone_number: formattedValue });
                          }}
                        />
                      ) : (
                        <CustomInput
                          value={form.getFieldValue("notification_channel")}
                          onChange={(e) =>
                            form.setFieldsValue({
                              notification_channel: e.target.value,
                            })
                          }
                          type={"email"}
                          placeholder={"email@example.com"}
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#5E5E5E"
                          lineHeight="38px"
                        />
                      )}
                    </Form.Item>
                    {/* <Form.Item name="notification_channel">
                    {(selectedOption === "MOBILE" || selectedOption === "WHATSAPP") && (
                      <CustomInput
                        type="tel"
                        value={form.getFieldValue("notification_channel")}
                        placeholder="(000) 000-0000"
                        height="36px"
                        border="0px"
                        bgColor="#F3F3F3"
                        textColor="#5E5E5E"
                        borderRadius="8px"
                        placeholderColor="#5E5E5E"
                        lineHeight="38px"
                      />
                    )}
                    {(selectedOption === "TEAMS" || selectedOption === "EMAIL" || selectedOption === "SLACK") && (
                      <CustomInput
                      value={form.getFieldValue("notification_channel")}
                        type="email"
                        placeholder="email@example.com"
                        height="36px"
                        border="0px"
                        bgColor="#F3F3F3"
                        textColor="#5E5E5E"
                        borderRadius="8px"
                        placeholderColor="#5E5E5E"
                        lineHeight="38px"
                      />
                    )}
                  </Form.Item> */}
                  </Col>
                )}
              </Row>
            </Space>
            <CustomButton
              text="Save"
              width={138}
              height={36}
              borderRadius={8}
              bgColor="#000"
              color="#fff"
              border="0px"
              fontSize={14}
              fontWeight={500}
              onClick={completeStep}
            />
          </Space>
        </Form>

        <div style={{ marginTop: "25px" }}>
          <Table
            columns={columns}
            dataSource={notificationList}
            pagination={false}
            className="custom-table"
            rowHoverable={false}
          />
        </div>

        {/* <CustomModal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          modalTitle="Connect your Slack team account"
          modalText="Proin ut dui sed metus pharetra hend rerit vel non mi. Nulla ornare faucibus ex, non facilisis nisl. Maecenas aliquet mauris ut tempus Proin ut dui sed metus pharetra hend rerit vel non mi. "
          modalSize={450}
        >
          <ConnectSlacks />
        </CustomModal> */}
      </div>
    </>
  );
};

export default Notifications;
